/* Le frecce della striscia Instagram.

   Lo scorrimento col dito e' quello nativo del browser: qui si aggiunge solo la
   possibilita' di avanzare di una foto per volta col clic, e si spegne la
   freccia quando da quella parte non c'e' piu' niente. */
(function () {
  function avvia(frecce) {
    var fila = frecce.parentNode.querySelector('.instagram__fila');
    if (!fila) return;
    var bottoni = frecce.querySelectorAll('.instagram__freccia');

    function passo() {
      var voce = fila.querySelector('.instagram__voce');
      if (!voce) return fila.clientWidth;
      var stile = getComputedStyle(fila);
      return voce.getBoundingClientRect().width + parseFloat(stile.columnGap || stile.gap || 0);
    }

    function aggiorna() {
      var resta = fila.scrollWidth - fila.clientWidth;
      bottoni.forEach(function (b) {
        var verso = Number(b.dataset.verso);
        /* un pixel di tolleranza: le larghezze in percentuale non tornano mai
           esatte e la freccia resterebbe accesa sull'ultimo scatto */
        b.disabled = verso < 0 ? fila.scrollLeft <= 1 : fila.scrollLeft >= resta - 1;
      });
    }

    bottoni.forEach(function (b) {
      b.addEventListener('click', function () {
        fila.scrollBy({ left: passo() * Number(b.dataset.verso), behavior: 'smooth' });
      });
    });

    fila.addEventListener('scroll', aggiorna, { passive: true });
    window.addEventListener('resize', aggiorna);
    aggiorna();
  }

  function tutti() {
    document.querySelectorAll('[data-instagram-frecce]').forEach(function (f) {
      if (!f.dataset.avviato) { f.dataset.avviato = '1'; avvia(f); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutti);
  else tutti();
  document.addEventListener('shopify:section:load', tutti);
})();
